import { render, staticRenderFns } from "./TipsHeader.vue?vue&type=template&id=3e0cfbe6"
import script from "./TipsHeader.vue?vue&type=script&lang=js"
export * from "./TipsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports